import { Box, Grid, Group, NumberInput, Select, SimpleGrid, Text, TextInput, Tooltip } from 'ui';
import { UseFormReturnType } from 'ui/Form';
import { IconInfo } from 'ui/Icons';

import { AddEditTicketFormType } from '../AddTicketForm.type';

type Props = {
  form: UseFormReturnType<AddEditTicketFormType>;
};

const TicketSalesStartInputs = ({ form }: Props) => {
  return (
    <SimpleGrid cols={2}>
      <Select
        label={
          form.values.ticket_window_data?.start?.type === 'x_time_before_event_date' ? (
            <Group justify="space-between">
              <Text type="label">Ticket Sales Start *</Text>
              <Tooltip
                label="Tickets will be available for purchase starting at 12:00 am on the day(s) before the event date."
                position="bottom"
                w="300px"
              >
                <IconInfo width={16} />
              </Tooltip>
            </Group>
          ) : (
            'Ticket Sales Start *'
          )
        }
        placeholder={`When Event is Published`}
        data={[
          { label: 'When Event is Published', value: 'on_publish_date' },
          { label: 'On Event Date', value: 'on_event_date' },
          { label: 'X Days Before Event Date', value: 'x_time_before_event_date' },
        ]}
        allowDeselect={false}
        {...form.getInputProps('ticket_window_data.start.type')}
        onChange={(val) => {
          form.getInputProps('ticket_window_data.start.type').onChange(val);

          form.setFieldValue(
            'ticket_window_data.start.timestamp',
            val === 'on_event_date' ? '00:00:00' : undefined
          );

          form.setFieldValue(
            'ticket_window_data.start.delta',
            val === 'x_time_before_event_date' ? 1 : undefined
          );
        }}
      />
      {form.values.ticket_window_data?.start?.type === 'on_event_date' && (
        <Group wrap="nowrap" align="end">
          <Grid>
            <Grid.Col span={5}>
              <Select.Times
                defaultValue={'00:00:00'}
                {...form.getInputProps('ticket_window_data.start.timestamp')}
              />
            </Grid.Col>
            <Grid.Col span={7}>
              <TextInput value={Intl.DateTimeFormat().resolvedOptions().timeZone} readOnly />
            </Grid.Col>
          </Grid>
        </Group>
      )}
      {form.values.ticket_window_data?.start?.type === 'x_time_before_event_date' && (
        <Group wrap="nowrap" align="end" gap="xs">
          <NumberInput
            defaultValue={1}
            allowNegative={false}
            {...form.getInputProps('ticket_window_data.start.delta')}
            w={'30%'}
            mb={'2px'}
          />
          <Text type="label" w={'100%'} mb={'8px'}>
            Day(s) before event date *
          </Text>
        </Group>
      )}
      {form.values.ticket_window_data?.start?.type === 'on_publish_date' && <Box />}
    </SimpleGrid>
  );
};

export default TicketSalesStartInputs;
